export enum AccountField {
    ID = 'id',
    BANK = 'bank',
    BIK = 'bik',
    NUMBER = 'number',
    CORRESPONDENT_NUMBER = 'correspondentNumber',
}